module.exports = __webpack_public_path__ + "09_mole.7499d9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/09_mole.png
// module id = x3ID
// module chunks = 0